import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: "80px",
        paddingTop: "40px",
        borderTop: "1px solid var(--border)",
        backgroundColor: "#fafbfc",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "32px 24px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            fontSize: "13px",
            color: "var(--muted)",
            gap: "4px",
            marginBottom: "24px",
          }}
        >
          <div style={{ fontWeight: 600 }}>Sugerir mejora</div>
          <a
            href="mailto:info@autonomoclaro.com"
            style={{
              color: "var(--brand)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand-ink)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--brand)")}
          >
            info@autonomoclaro.com
          </a>
        </div>

        <div
          style={{
            fontSize: "11px",
            lineHeight: "1.6",
            color: "#9ca3af",
            padding: "16px",
            backgroundColor: "rgba(249, 250, 251, 0.8)",
            borderRadius: "8px",
            border: "1px solid #e5e7eb",
            marginBottom: "20px",
          }}
        >
          <strong style={{ display: "block", marginBottom: "8px", color: "#6b7280" }}>
            Aviso:
          </strong>
          Esta herramienta realiza estimaciones basadas en la normativa fiscal vigente (LIRPF 2025 y cuota de autónomos 2025) con fines meramente informativos. No constituye asesoramiento vinculante ni sustituye la labor de un profesional colegiado. El desarrollador no se hace responsable de decisiones tomadas basadas únicamente en estos datos. Consulta siempre con tu gestoría antes de presentar modelos oficiales.
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "13px",
            color: "var(--muted)",
          }}
        >
          <Link
            to="/privacy"
            style={{
              color: "var(--muted)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
          >
            Privacidad
          </Link>
          <span style={{ color: "#d1d5db" }}>·</span>
          <Link
            to="/cookies"
            style={{
              color: "var(--muted)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
          >
            Cookies
          </Link>
          <span style={{ color: "#d1d5db" }}>·</span>
          <Link
            to="/terms"
            style={{
              color: "var(--muted)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
          >
            Términos
          </Link>
          <span style={{ color: "#d1d5db" }}>·</span>
          <Link
            to="/legal"
            style={{
              color: "var(--muted)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
          >
            Aviso legal
          </Link>
          <span style={{ color: "#d1d5db" }}>·</span>
          <a
            href="mailto:info@autonomoclaro.com"
            style={{
              color: "var(--muted)",
              textDecoration: "none",
              transition: "color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
          >
            Contacto
          </a>
        </div>

        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
            fontSize: "12px",
            color: "#9ca3af",
          }}
        >
          © {new Date().getFullYear()} Numhaus. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
